import { fetchModels } from './models';
import { fetchMaterials } from './materials';
import { fetchScenes } from './scenes';

const initialState = {
  models: {},
  materials: {},
  scenes: {},
  search: {
    models: [],
    materials: [],
    scenes: [],
  },
  view: null,
};

const SET_SELECT = 'SET_SELECT';
const SET_VIEW = 'SET_VIEW';
const SET_SEARCH = 'SET_SEARCH';
const ADD_SEARCH = 'ADD_SEARCH';
const CLEAR_DATA = 'CLEAR_DATA';

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECT:
      return { ...state, [action.payload.type]: action.payload.value };
    case SET_VIEW:
      return { ...state, view: action.payload };
    case CLEAR_DATA:
      return initialState;
    default:
      return state;
  }
};

export const getSelected = (type, state) => state.explorer[type];

export const setSelected = (type, value) => ({
  type: SET_SELECT,
  payload: { type, value },
});

const setSeachResult = result => ({ type: SET_SEARCH, payload: result });

export const getView = state => state.explorer.view;

export const setView = view => ({ type: SET_VIEW, payload: view });

export const searchItems = value => async dispatch => {
  const models = await fetchModels({ page: 0, tag: value });
  const materials = await fetchMaterials({ page: 0, tag: value });
  const scenes = await fetchScenes({ page: 0, tag: value });
  dispatch(setSeachResult({ models, materials, scenes }));
};



// WEBPACK FOOTER //
// ./src/modules/explorer.js